/**
 * Absolute origin to prefix on every /api/* call. Empty string in normal
 * web mode (calls are same-origin, hit the Express layer); a fully
 * qualified URL when bundled into the Capacitor mobile shell or any
 * other host that doesn't share the API's origin.
 *
 * Set at build time via VITE_API_BASE_URL; trailing slash trimmed.
 */
const RAW = (import.meta.env.VITE_API_BASE_URL ?? '').trim();
export const API_BASE = RAW.replace(/\/$/, '');

export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}
